<template>
  <div class="dbpControl">
    <v-text-field
        v-model="textValue"
        :type="palpEnabled ? 'text' : 'number'"
        hide-details
        outlined
        dense
        :readonly="palpEnabled"
    >
      <template v-slot:append-outer>
        <v-checkbox
            v-model="palpEnabled"
            label="Palp"
            class="dbpCheckbox mt-0"
            hide-details
            dense
        />
      </template>
    </v-text-field>
  </div>
</template>
<script>
export default {
  name: 'DBP',
  props: {
    value: {
      type: String,
    },
  },

  computed: {
    palpEnabled: {
      get() {
        return this.value && this.value === 'P';
      },
      set(value) {
        if (value) {
          this.textValue = 'P';
        } else {
          this.textValue = null;
        }
      },
    },
    textValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style lang="scss">
.dbpControl {
  .v-input__append-outer {
    margin-top: 5px !important;
  }
  .dbpCheckbox label {
    top: 0px !important;
  }
}
</style>
